import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import rootReducer from './reducer'

const persist = store => next => action => {
    next(action)
    localStorage.setItem('state', JSON.stringify(store.getState()))
}

const middleware = applyMiddleware(persist)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(rootReducer, composeEnhancers(middleware))

ReactDOM.render(<Provider store={store}><App/></Provider>, document.getElementById('root'))

